import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DistributionForm from './DistributionForm';
import DistributionChart from './DistributionChart';

import { doPdsAndCutoffsExist } from 'store/scenes/distributions/selectors';

const Distributions = props =>
  <div className="page-main__indent">
    <div className="flex flex-grow">
      <div className="settings-width mb-15 mr-15">
        <DistributionForm />
      </div>

      <div id="right-pane" className="graph-width mb-15">
        {props.showDistributionChart &&
          <DistributionChart />
        }
      </div>
    </div>
  </div>;

Distributions.propTypes = {
  showDistributionChart: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  const pdsAndCutoffsExist = doPdsAndCutoffsExist(state);

  return { showDistributionChart: pdsAndCutoffsExist };
};

export default connect(mapStateToProps)(Distributions);
